import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyRoutingModule } from './company-routing.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CustomMaterialModule } from '../custom-material.module';
import { ReactiveFormsModule , FormsModule} from '@angular/forms';
import { ShareModule } from '../_share/share.module';

import { CompanyDefaultComponent } from './company-default/company-default.component';
import { MyCompanyComponent } from './my-company/my-company.component';
import { PropertiesComponent, CreatePropertyDialog } from './properties/properties.component';
import { PropertyComponent } from './property/property.component';
import { RegistrationComponent } from './registration/registration.component';

@NgModule({
  declarations: [
    CompanyDefaultComponent,
    MyCompanyComponent,
    PropertiesComponent, CreatePropertyDialog, PropertyComponent, RegistrationComponent, CompanyDefaultComponent,
  ],
  imports: [
    CommonModule,
    CompanyRoutingModule,
    FlexLayoutModule,
    CustomMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    ShareModule
  ],
  providers: [],
  entryComponents: [ CreatePropertyDialog, ]
})
export class CompanyModule { }
